import {useParams, useSearchParams} from "react-router-dom"
import {z} from "zod"

/* eslint-disable @typescript-eslint/no-explicit-any */

export const useTypedParams = <T extends z.ZodType<any, any>>(
  schema: T,
): z.infer<T> => schema.parse(useParams())

export const useTypedSearchParams = <T extends z.ZodType<any, any>>(
  schema: T,
  defaultParams: z.infer<T>,
): z.infer<T> => {
  const [searchParams] = useSearchParams()
  const parsed = schema.safeParse(Object.fromEntries(searchParams.entries()))

  if (parsed.success) {
    return parsed.data
  } else {
    return defaultParams
  }
}

/* eslint-disable @typescript-eslint/no-explicit-any */
